<ng-container *ngIf="unselectedFilters$ | async as unselectedFilters">
    <button
        class="apply-filter-btn"
        [matMenuTriggerFor]="menu"
        mat-icon-button
        matTooltip="Apply filter"
        matTooltipClass="redClass"
        matTooltipPosition="above">
        <mat-icon class="toolbar_icon_color">filter_alt</mat-icon>
    </button>
    <mat-menu #menu="matMenu" class="filter_items">
        <ng-container
            *ngIf="unselectedFilters.length > 0; else noAvailableFilters">
            <button
                (click)="selectFilter(filter)"
                *ngFor="let filter of unselectedFilters"
                mat-menu-item>
                {{ filter.name }}
            </button>
        </ng-container>
        <ng-template #noAvailableFilters>
            <span class="empty-set">No filters avaialble</span>
        </ng-template>
    </mat-menu>
</ng-container>
